/**
 * Registers the service worker and remembers how it went.
 *
 * Registration is fire-and-forget at startup, but the outcome has to reach the
 * UI: a failure that is swallowed leaves the menu claiming offline support is
 * still "being prepared" forever, which is worse than saying it did not work.
 */
let failure: string | null = null;
const listeners = new Set<() => void>();

export function swFailure(): string | null {
  return failure;
}

export function onSwChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function announce(err: string | null) {
  failure = err;
  for (const fn of listeners) fn();
}

/** Called once, from the entry point, after load. */
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.register("/sw.js").then(
    () => announce(null),
    (err: unknown) => announce(err instanceof Error ? err.message : String(err))
  );
}
